import { AnimatePresence } from 'motion/react'
import { useLocation, useOutlet } from 'react-router-dom'
import { PageTransition } from './PageTransition'
import { useSmoothScroll } from './useSmoothScroll'

/**
 * Layout route element for the public marketing site. Cross-fades pages on
 * navigation: the outgoing page exits before the incoming one enters
 * (mode="wait"). `useOutlet` captures the outgoing element so it can finish
 * its exit after the location has already changed.
 *
 * Do NOT pass `initial={false}` to this AnimatePresence: motion propagates it
 * through context to every nested motion element, which would make all
 * HeroReveal / ScrollReveal blocks skip their entrance on a direct page load.
 */
export function PublicShell() {
  const location = useLocation()
  const outlet = useOutlet()

  // Inertial scrolling on desktop fine-pointer viewports (marketing feel);
  // no-op on touch and under prefers-reduced-motion.
  useSmoothScroll()

  return (
    <AnimatePresence mode="wait">
      <PageTransition key={location.pathname} pathname={location.pathname} hash={location.hash}>
        {outlet}
      </PageTransition>
    </AnimatePresence>
  )
}
